import Modal from "./modal.container";
import ModalFooter from "./footer.container";
export { ContentWrapper } from "./modal.component";
export { ModalFooter };
export default Modal;
